import { connect } from 'react-redux';

import eventsActionCreators from '_store/_actions/events';
import EventRegistrationPage from './EventRegistrationPage';

const mapStateToProps = state => ({
  event: state.events.currentEvent,
  registrationCount: state.events.registrationCount,
  isLoading: state.events.isLoading,
  error: state.events.error,
});

const mapDispatchToProps = {
  onFetchEvent: eventsActionCreators.fetchEvent,
  onFetchEventPublic: eventsActionCreators.fetchEventPublic,
  onCreateRegistration: eventsActionCreators.createEventRegistration,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventRegistrationPage);
